import { render, staticRenderFns } from "./CoExercise.vue?vue&type=template&id=d1438564&scoped=true&"
import script from "./CoExercise.vue?vue&type=script&lang=js&"
export * from "./CoExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1438564",
  null
  
)

export default component.exports